const INTITIAL_STATE = {
    productList: [],
  };
  
  const productReducer = (state = INTITIAL_STATE, action) => {
    switch (action.type) {
      case "SAVE_PRODUCTS":
        return {
          ...state,
          productList: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default productReducer;
  